<template>
  <div>
    <bannerTop ref="bannerTop" arrow="always" :bannerData="bannerData"></bannerTop>
    <div class="myTitle_box" style="padding-top: 78px">
      <div class="myTitle">公司动态</div>
      <div class="myTitle_behind">JUQUNEWS</div>
    </div>
    <div class="news">
      <div
        v-show="isMore ? true : i <= 8"
        class="news_item"
        v-for="(item, i) in newsList"
        :key="i"
        @click="selectNews(item)"
      >
        <div v-if="item.category" class="news_item_category">{{ item.category }}</div>
        <img :src="item.img" alt="" />
        <div class="news_item_name_box">
          <div class="news_item_name">{{ item.title }}</div>
          <div>{{ item.time }}</div>
        </div>
      </div>
      <div class="new_btn_box">
        <div class="new_btn flexVerticalCenter" @click="isMore = !isMore">
          {{ isMore ? "收起" : "查看更多" }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bannerTop from "@/components/pc/bannerTop";
export default {
  components: {
    bannerTop,
  },
  data() {
    return {
      // banner数据
      bannerData: [
        {
          img: require("@/assets/pc/news/banner1.png"),
          url: "https://www.163.com/news/article/KSVPBD1K00019UD6.html",
        },
        {
          img: require("@/assets/pc/news/banner2.png"),
          url: "https://www.dzwww.com/xinwen/jishixinwen/202609/t20260911_18107958.htm",
        },
        {
          img: require("@/assets/pc/news/banner3.png"),
          url:
            "https://www.shxwcb.com/#/detail/DC3ADAF1F1C432D5186DDC6ABB91A8FFE7B1616B92B12CA6BFE8494AC1C7ADD7",
        },
      ],
      newsList: [
        {
          img: require("@/assets/pc/news/news (1).png"),
          name: "新闻晨报",
          title: "全业务线覆盖 聚趣教育建成办学与科技协同体系",
          category: "",
          time: "2026-09-11",
          url:
            "https://www.shxwcb.com/#/detail/A15B3009BE55127F71939C39086D1E4DAAF230FC5A48D7FE6808CBE0443EAC4C",
        },
        {
          img: require("@/assets/pc/news/news (2).png"),
          name: "TOM新闻",
          title: "聚趣西语布局精细化私域 借助智能能力优化用户运营",
          category: "",
          time: "2026-09-04",
          url: "https://news.tom.com/202609/4291859059.html",
        },
        {
          img: require("@/assets/pc/news/news (3).png"),
          name: "ZAKER新闻",
          title: "聚趣云创发布企业级智能体聚趣智能 聚趣教育成首个落地标杆",
          category: "",
          time: "2026-09-04",
          url: "https://www.myzaker.com/article/PP6a9a84cf1bc8e0522600000e",
        },
        {
          img: require("@/assets/pc/news/news (4).png"),
          name: "ZAKER新闻",
          title: "自研 AI系统持续迭代，聚趣教育以科技重塑语言学习路径",
          category: "",
          time: "2026-04-27",
          url: "https://www.myzaker.com/article/69ef32541bc8e0252c000008",
        },
        {
          img: require("@/assets/pc/news/news (5).png"),
          name: "大京新闻网",
          title: "聚趣教育荣获湖南省”专精特新”中小企业认定",
          category: "专精特新",
          time: "2026-05-15",
          url: "http://www.fx116.com.cn/a/wangyishangxunwenzilian/133859.html",
        },
        {
          img: require("@/assets/pc/news/news (6).png"),
          name: "大众网新闻",
          title: "96.12% 聚趣教育公布最新学员综合通过率",
          category: "",
          time: "2026-09-11",
          url: "https://www.dzwww.com/xinwen/jishixinwen/202609/t20260911_18107958.htm",
        },
        {
          img: require("@/assets/pc/news/news (7).png"),
          name: "飞象网",
          title: "AI赋能语言学习，聚趣教育智能系统让课堂更高效",
          category: "",
          time: "2026-04-16",
          url: "http://www.cctime.com/html/2026-4-16/1732752.htm",
        },
        {
          img: require("@/assets/pc/news/news (8).png"),
          name: "凤凰网",
          title: "行业标准引领:聚趣教育如何参与制定教育科技规范",
          category: "",
          time: "2026-04-14",
          url: "https://baby.ifeng.com/c/8sJw8zbPIV5",
        },
        {
          img: require("@/assets/pc/news/news (9).png"),
          name: "凤凰网",
          title: "全球布局下的本土深耕 : 聚趣教育跨文化教学服务体系构建",
          category: "",
          time: "2026-04-13",
          url: "http://baby.ifeng.com/c/8sIUop0o5jF",
        },
        {
          img: require("@/assets/pc/news/news (10).png"),
          name: "凤凰网区域",
          title: "聚趣教育分级教学体系再升级，助学员高效突破小语种壁垒",
          category: "",
          time: "2026-04-29",
          url: "https://baby.ifeng.com/c/8sishHCryyn",
        },
        {
          img: require("@/assets/pc/news/news (11).png"),
          name: "极目新闻",
          title: "聚趣云创联合聚趣教育发布三年智能化规划",
          category: "",
          time: "2026-09-11",
          url: "https://www.ctdsb.net/s522_202609/1605833.html",
        },
        {
          img: require("@/assets/pc/news/news (12).png"),
          name: "极目新闻",
          title: "聚趣教育德语法语西语课程升级，分级强化体系精准攻坚",
          category: "",
          time: "2026-04-28",
          url: "https://www.ctdsb.net/s522_202604/1478924.html",
        },
        {
          img: require("@/assets/pc/news/news (13).png"),
          name: "今日头条（商业与报道）",
          title: "留学规划年龄提前，聚趣教育布局低龄留学服务体系",
          category: "",
          time: "2026-04-15",
          url: "https://www.toutiao.com/article/7628922659895640622/",
        },
        {
          img: require("@/assets/pc/news/news (14).png"),
          name: "今日头条-热度新闻",
          title: "沉淀教学经验知识库 聚趣教育降低师资流动影响",
          category: "",
          time: "2026-09-08",
          url: "https://www.toutiao.com/article/7683090081141326376/",
        },
        {
          img: require("@/assets/pc/news/news (15).png"),
          name: "今日头条-中国企业报数字经济",
          title: "技术驱动服务升级 : 聚趣教育全流程留学服务的数字化重塑",
          category: "",
          time: "2026-04-15",
          url:
            "https://www.toutiao.com/article/7628776404468908554/?upstream_biz=toutiao_pc&wxshare_count=2&utm_source=&source=m_redirect&wid=1776216040356",
        },
        {
          img: require("@/assets/pc/news/news (16).png"),
          name: "砍柴网",
          title: "“AI+教育” 政策出台，聚趣教育AI学习系统率先落地见效",
          category: "",
          time: "2026-04-29",
          url: "https://news.ikanchai.com/2026/0429/656286.shtml",
        },
        {
          img: require("@/assets/pc/news/news (17).png"),
          name: "砍柴网",
          title: "聚趣教育AI学习系统再升级，个性化学习路径覆盖全学段",
          category: "",
          time: "2026-04-21",
          url: "https://news.ikanchai.com/2026/0421/655252.shtml",
        },
        {
          img: require("@/assets/pc/news/news (18).png"),
          name: "砍柴网",
          title: "技术底座硬实力 : 聚趣教育 AI智能学习系统4.0架构解析",
          category: "",
          time: "2026-04-13",
          url: "https://news.ikanchai.com/2026/0413/654471.shtml",
        },
        {
          img: require("@/assets/pc/news/news (19).png"),
          name: "搜狐",
          title: "聚趣教育学习系统提速 依托聚趣云创统一算力供给",
          category: "",
          time: "2026-09-08",
          url: "https://www.sohu.com/a/1073410269_122977143",
        },
        {
          img: require("@/assets/pc/news/news (20).png"),
          name: "搜狐",
          title: "留学门槛收紧之年，聚趣教育用语言实力为学员铺路",
          category: "",
          time: "2026-04-18",
          url: "https://www.sohu.com/a/1011335696_122490004",
        },
        {
          img: require("@/assets/pc/news/news (21).png"),
          name: "搜狐新闻",
          title: "技术立企，聚趣教育以AI研发实力荣获湖南省“专精特新”认定",
          category: "专精特新",
          time: "2026-05-15",
          url: "https://biznews.sohu.com/a/1023145981_121198369",
        },
        {
          img: require("@/assets/pc/news/news (22).png"),
          name: "腾讯新闻",
          title: "双向闭环流转 聚趣云创与聚趣教育完成能力协同升级",
          category: "",
          time: "2026-09-11",
          url:
            "https://news.qq.com/rain/a/20260911A0CEM100?id=20260911A0CEM100&path=a&app=news&suid=&redirect_pc=1",
        },
        {
          img: require("@/assets/pc/news/news (23).png"),
          name: "腾讯新闻",
          title: "多语种咨询需求攀升 聚趣教育上线智能客服体系",
          category: "",
          time: "2026-09-08",
          url: "https://news.qq.com/rain/a/20260908A0DLQE00",
        },
        {
          img: require("@/assets/pc/news/news (24).png"),
          name: "腾讯新闻",
          title: "聚趣教育解析成人语言习得规律助力在职学员高效提升",
          category: "",
          time: "2026-04-15",
          url:
            "https://news.qq.com/rain/a/20260415A066OI00?uid=102086552975&chlid=user_center&suid=&media_id=",
        },
        {
          img: require("@/assets/pc/news/news (25).png"),
          name: "腾讯新闻",
          title: "课程质量监控体系：聚趣教育如何保障92%完课率的技术支撑",
          category: "",
          time: "2026-04-14",
          url: "https://news.qq.com/rain/a/20260414A066JE00",
        },
        {
          img: require("@/assets/pc/news/news (26).png"),
          name: "腾讯新闻",
          title: "聚趣教育强化服务质量管控 筑牢服务品质防线",
          category: "",
          time: "2026-04-13",
          url: "https://news.qq.com/rain/a/20260413A07FID00",
        },
        {
          img: require("@/assets/pc/news/news (27).png"),
          name: "网易",
          title: "聚趣教育启动“世界名校教师计划”，外籍师资引入再提速",
          category: "",
          time: "2026-04-21",
          url: "https://www.163.com/dy/article/KR2K2TVU0556KQKA.html",
        },
        {
          img: require("@/assets/pc/news/news (28).png"),
          name: "网易",
          title: "聚趣教育将外语能力转化为学员实际职场竞争力",
          category: "",
          time: "2026-04-15",
          url: "https://www.163.com/dy/article/KQJ3URBL0556J44F.html",
        },
        {
          img: require("@/assets/pc/news/news (29).png"),
          name: "网易",
          title: "课程效率革命：聚趣教育如何将小语种学习周期压缩30%",
          category: "",
          time: "2026-04-13",
          url: "https://www.163.com/dy/article/KQDOHDS50556KQKA.html",
        },
        {
          img: require("@/assets/pc/news/news (30).png"),
          name: "未来网新闻",
          title: "学习数据回流课堂 聚趣教育教学改进实现有据可依",
          category: "",
          time: "2026-09-08",
          url: "https://news.k618.cn/finance/money/202609/t20260908_20058346.html",
        },
        {
          img: require("@/assets/pc/news/news (31).png"),
          name: "潇湘晨报网",
          title: "打通教务教学数据壁垒 聚趣教育提速运营决策效率",
          category: "",
          time: "2026-09-09",
          url: "https://www.xxcb.cn/details/9BHHXcSKw_6aa0c49584201708686012bf.html",
        },
        {
          img: require("@/assets/pc/news/news (32).png"),
          name: "新浪新闻",
          title: "留学语言门槛全面升级，聚趣教育小语种备考方案精准破局",
          category: "",
          time: "2026-04-29",
          url: "https://news.sina.com.cn/sx/2026-04-29/detail-inhwefva7746062.shtml",
        },
        {
          img: require("@/assets/pc/news/news (33).png"),
          name: "新浪新闻",
          title: "聚趣教育智能学习系统走进校园，本土教育科技企业加速赋能",
          category: "",
          time: "2026-04-21",
          url: "https://news.sina.com.cn/sx/2026-04-22/detail-inhvhmia6796588.shtml",
        },
        {
          img: require("@/assets/pc/news/news (34).png"),
          name: "新浪新闻",
          title: "聚趣教育构建学员全周期成长陪伴机制提升学习留存",
          category: "",
          time: "2026-04-15",
          url: "https://news.sina.com.cn/sx/2026-04-15/detail-inhuqnax8417592.shtml",
        },
        {
          img: require("@/assets/pc/news/news (35).png"),
          name: "新浪新闻",
          title: "教材层面决策方法论：聚趣教育如何选择与研发教材体系",
          category: "",
          time: "2026-04-13",
          url: "https://news.sina.com.cn/sx/2026-04-14/detail-inhuixwz9768860.shtml",
        },
        {
          img: require("@/assets/pc/news/news (36).png"),
          name: "新闻晨报",
          title: "聚趣教育 AI 学习系统完成升级 底层接入聚趣云创技术",
          category: "",
          time: "2026-09-08",
          url:
            "https://www.shxwcb.com/#/detail/DC3ADAF1F1C432D5186DDC6ABB91A8FFE7B1616B92B12CA6BFE8494AC1C7ADD7",
        },
        {
          img: require("@/assets/pc/news/news (37).png"),
          name: "中国报业网",
          title: "随着“一带一路”合作深化，聚趣教育抢抓小语种人才新机遇",
          category: "",
          time: "2026-04-17",
          url:
            "https://www.cnpiw.cn/a/fuwuzhongxin/zixun/2026/0417/36723.html?1776396116",
        },
        {
          img: require("@/assets/pc/news/news (38).png"),
          name: "中国财富网",
          title: "从语言到出国，聚趣教育打通留学全程服务链",
          category: "",
          time: "2026-04-16",
          url: "https://www.cfbond.com/2026/04/16/991127040.html",
        },
        {
          img: require("@/assets/pc/news/news (39).png"),
          name: "中国发展网",
          title: "招生转化效率提升 聚趣教育落地智能线索承接体系",
          category: "",
          time: "2026-09-08",
          url: "http://www.chinadevelopment.com.cn/zxsd/2026/0908/2014449.shtml",
        },
        {
          img: require("@/assets/pc/news/news (40).png"),
          name: "中国经济新闻网",
          title: "内容生态建设方法论：聚趣教育如何持续产出高质量教学资源",
          category: "",
          time: "2026-04-14",
          url: "https://www.cet.com.cn/xwsd/10336628.shtml",
        },
        {
          img: require("@/assets/pc/news/news (41).png"),
          name: "中国日报网",
          title: "同源双轮驱动 聚趣教育与聚趣云创探索办学与企服协同模式",
          category: "",
          time: "2026-09-04",
          url: "https://cn.chinadaily.com.cn/a/202609/04/WS6a9a88dee4b09a165c788243.html",
        },
        {
          img: require("@/assets/pc/news/news (42).png"),
          name: "中华经济发展网",
          title: "构建教研数据闭环 聚趣教育推动课程持续迭代",
          category: "",
          time: "2026-09-08",
          url: "http://www.zzsz.net.cn/news/202609/122998.html",
        },
        {
          img: require("@/assets/pc/news/news (43).png"),
          name: "中华经济发展网",
          title: "聚趣教育留学顾问深度解读主要目的地招生政策趋势",
          category: "",
          time: "2026-04-16",
          url: "http://www.zzsz.net.cn/news/202604/118135.html",
        },
        {
          img: require("@/assets/pc/news/news (44).png"),
          name: "中华网",
          title: "从粗放群发转向分层运营 聚趣教育私域留存实现增长",
          category: "",
          time: "2026-09-08",
          url: "https://hea.china.com/articles/20260908/202609081957081.html",
        },
        {
          img: require("@/assets/pc/news/news (45).png"),
          name: "中华网",
          title: "以“人才密度”构筑核心壁垒，聚趣教育荣获湖南省“专精特新”认定",
          category: "专精特新",
          time: "2026-05-15",
          url: "https://tech.china.com/articles/20260515/202605151869723.html",
        },
        {
          img: require("@/assets/pc/news/news (46).png"),
          name: "中华网",
          title: "行业低价内卷加剧，聚趣教育以品质路线穿越市场洗牌期",
          category: "",
          time: "2026-04-27",
          url: "https://hea.china.com/articles/20260427/202604271856472.html",
        },
        {
          img: require("@/assets/pc/news/news (47).png"),
          name: "中华网",
          title: "聚趣教育“四师陪跑”协同机制：四个角色如何形成服务闭环",
          category: "",
          time: "2026-04-13",
          url: "https://hea.china.com/articles/20260413/202604131845788.html",
        },
        {
          img: require("@/assets/pc/news/news (48).png"),
          name: "中华网科技",
          title: "教育科技产品迭代逻辑：聚趣教育AI智能学习系统的演进路径",
          category: "",
          time: "2026-04-14",
          url: "https://tech.china.com/articles/20260414/202604141847034.html",
        },
        {
          img: require("@/assets/pc/news/news (49).png"),
          name: "中华网新闻",
          title: "聚趣教育留学服务实现全流程覆盖，从语言学习到海外定居无缝衔接",
          category: "",
          time: "2026-04-21",
          url: "https://digi.china.com/articles/20260421/202604211852162.html",
        },
        {
          img: require("@/assets/pc/news/news (50).png"),
          name: "中华网新闻",
          title: "TOPIK居家机考推行，聚趣教育韩语课程适配新形式",
          category: "",
          time: "2026-04-16",
          url: "https://digi.china.com/articles/20260416/202604161848992.html",
        },
        {
          img: require("@/assets/pc/news/news (51).png"),
          name: "中华网新闻",
          title: "聚趣教育多语种学习方案：系统规划一人掌握多门外语",
          category: "",
          time: "2026-04-15",
          url: "https://digi.china.com/articles/20260415/202604151847707.html",
        },
        {
          img: require("@/assets/pc/news/news (52).png"),
          name: "资讯中国",
          title: "国际化教学服务体系：聚趣教育52国学员的本地化实践",
          category: "",
          time: "2026-04-15",
          url: "http://www.zhgnews.com/news/76750.html",
        },
      ],
      isMore: false,
    };
  },
  created() {
    this.newsList = this.sortNewsList(this.newsList);
  },
  methods: {
    selectNews(item) {
      window.open(item.url);
    },
    sortNewsList(list) {
      return [...list].sort((a, b) => {
        // 1. 判断 category 是否有值
        const aHasCategory = a.category && a.category.trim() !== "";
        const bHasCategory = b.category && b.category.trim() !== "";

        // 有 category 的排前面
        if (aHasCategory !== bHasCategory) {
          return aHasCategory ? -1 : 1;
        }

        // 2. category 状态相同，按时间倒序
        const timeA = new Date(a.time).getTime();
        const timeB = new Date(b.time).getTime();
        return timeB - timeA; // 倒序：新的在前
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.news {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 40px 0 98px;
  .news_item {
    width: 384px;
    height: 341px;
    background: #ffffff;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    cursor: pointer;
    position: relative;
    .news_item_category {
      padding: 4px 8px;
      background: #ff8529;
      border-radius: 0px 8px 0px 8px;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      position: absolute;
      right: 0;
      top: 0;
    }
    img {
      width: 100%;
      height: 197px;
      object-fit: cover;
      border-radius: 8px 8px 0px 0px;
    }
    .news_item_name_box {
      width: 100%;
      padding: 20px 16px;
      box-sizing: border-box;
      font-weight: 400;
      font-size: 16px;
      color: #666666;
      .news_item_name {
        font-weight: bold;
        font-size: 22px;
        color: #333333;
        padding-bottom: 20px;
      }
    }
  }
  .new_btn_box {
    width: 1200px;
    margin: 0 auto;
    .new_btn {
      width: 390px;
      height: 68px;
      border-radius: 34px;
      border: 2px solid #4d4dd9;
      margin: 36px auto 0;
      font-weight: 500;
      font-size: 28px;
      color: #4d4dd9;
      cursor: pointer;
    }
  }
}
</style>
